export const SHIPPING_ADDRESS_TRANSLATIONS = {
    "cs": {
        "requiredMessage": "Povinný údaj",
        "shippingPhoneLabel": "Telefonni cislo behem dne",
        "shippingNameLabel": "Jméno",
        "shippingEmailLabel": "Emailová adresa",
        "shippingEmailInvalidMessage": "Toto není platná emailová adresa",
        "shippingAddressDefaultLabel": "Uveďte tuto dodací adresu jako aktuální.",
        "shippingAddressSaveLabel": "Uložte tuto adresu do mého účtu"
    },
    "da": {
        "requiredMessage": "Dette felt skal udfyldes.",
        "shippingPhoneLabel": "Tlf. i dagtimerne",
        "shippingNameLabel": "Navn",
        "shippingEmailLabel": "E-Mail-Adresse",
        "shippingEmailInvalidMessage": "Den opgivne e-mail-adresse er ugyldig eller findes ikke i vores system.",
        "shippingAddressDefaultLabel": "Gem denne adresse som min standardforsendelsesadresse.",
        "shippingAddressSaveLabel": "Gem denne adresse under Min kont"
    },
    "de": {
        "requiredMessage": "Dieses Feld muss ausgefüllt werden.",
        "shippingPhoneLabel": "Telefon beruflich",
        "shippingNameLabel": "Kontoinhaber",
        "shippingEmailLabel": "E-Mail-Adresse",
        "shippingEmailInvalidMessage": "Die E-Mail-Adresse ist ungültig oder kann nicht im System gefunden werden.",
        "shippingAddressDefaultLabel": "Diese Lieferadresse als Standard festlegen.",
        "shippingAddressSaveLabel": "Adresse in meinem Account speichern."
    },
    "de_DE": {
        "shippingEmailInvalidMessage": "Die von Ihnen angegebene E-Mail-Adresse ist ungültig oder nicht im System gespeichert."
    },
    'en': {
        'requiredMessage': 'This field is required.',
        'shippingPhoneLabel': 'Daytime Phone Number',
        'shippingNameLabel': 'Full Name',
        'shippingNamePlaceholder': 'Full Name',
        'shippingNameInvalidMessage': 'This field is invalid.',
        'shippingEmailInvalidMessage': 'This is not a valid email address.',
        'shippingEmailLabel': 'Email Address',
        'shippingEmailPlaceholder': 'Email Address',
        'shippingInstructionsInvalidMessage': 'This field can only contain characters 0-9.',
        'shippingInstructionsLabel': 'Shipping Instructions (optional)',
        'shippingInstructionsPlaceholder': 'Shipping Instructions',
        'shippingAddressDefaultLabel': 'Make this my default shipping address.',
        'shippingAddressSaveLabel': 'Save this address to My Account'
    },
    "en_BR": {
        "shippingPhoneLabel": "Daytime Phone Number",
        "shippingNameLabel": "Name"
    },
    "en_CA": {
        "shippingPhoneLabel": "Shipping Phone Number"
    },
    "en_HK": {
        "shippingPhoneLabel": "Phone Number",
        "shippingNameLabel": "Name (same as HKID)"
    },
    "en_ID": {
        "shippingPhoneLabel": "Home Phone"
    },
    "en_DE": {
        "shippingPhoneLabel": "Daytime Phone Number: (optional)",
        "shippingMobilePhoneLabel": "Mobile Phone"
    },
    "en_ES": {
        "shippingPhoneLabel": "Daytime Phone Number: (optional)",
        "shippingMobilePhoneLabel": "Mobile Phone"
    },
    "en_FR": {
        "shippingPhoneLabel": "Daytime Phone Number: (optional)",
        "shippingMobilePhoneLabel": "Mobile Phone"
    },
    "en_GB": {
        "shippingPhoneLabel": "Daytime Phone Number: (optional)",
        "shippingMobilePhoneLabel": "Mobile Phone"
    },
    "en_HU": {
        "shippingPhoneLabel": "Daytime Phone Number: (optional)",
        "shippingMobilePhoneLabel": "Mobile Phone"
    },
    "en_MY": {
        "shippingPhoneLabel": "Home Phone"
    },
    "en_NO": {
        "shippingPhoneLabel": "Daytime Phone Number: (optional)",
        "shippingMobilePhoneLabel": "Mobile Phone"
    },
    "en_NZ": {
        "shippingPhoneLabel": "Shipping Phone Number: (xx xxxx xxxx)"
    },
    "en_PH": {
        "shippingPhoneLabel": "Home Phone"
    },
    "en_SG": {
        "shippingPhoneLabel": "Home Phone/Mobile Phone"
    },
    "en_TH": {
        "shippingPhoneLabel": "Home Phone",
        "shippingInstructionsLabel": "Mobile Number/ Shipping Instructions (Optional)"
    },
    "en_TR": {
        "shippingNameLabel": "Name"
    },
    "en_UA": {
        "shippingPhoneLabel": "Daytime Phone Number: (optional)",
        "shippingNameLabel": "Please enter recipient name in Cyrillic in format:Last Name First Name Patronymic"
    },
    "en_US": {
        "shippingPhoneLabel": "Daytime Phone Number: (xxx-xxx-xxxx)"
    },
    "en_VN": {
        "shippingPhoneLabel": "Home/Mobile Phone Number"
    },
    "en_ZA": {
        "shippingAddressDefaultLabel": "Use as my Permanent Address",
        "shippingAddressSaveLabel": "Add to My Account",
        "shippingPhoneLabel": "Cell Phone Number: (0XXXXXXXXX)"
    },
    'es': {
        'requiredMessage': 'Este campo es obligatorio',
        'shippingPhoneLabel': 'Número de teléfono durante el día',
        'shippingNameLabel': 'Nombre',
        'shippingNamePlaceholder': 'Nombre',
        'shippingNameInvalidMessage': 'Este campo no es válido',
        'shippingEmailInvalidMessage': 'Esta no es una dirección de correo electrónico válida.',
        'shippingEmailLabel': 'Dirección de correo electrónico',
        'shippingEmailPlaceholder': 'Dirección de correo electrónico',
        'shippingInstructionsInvalidMessage': 'Este campo solo puede contener caracteres 0-9.',
        'shippingInstructionsLabel': 'Instrucciones de envío (opcional)',
        'shippingInstructionsPlaceholder': 'Instrucciones de envío',
        'shippingAddressDefaultLabel': 'Hacer que esta sea mi dirección de envío predeterminada',
        'shippingAddressSaveLabel': 'Guardar esta dirección en Mi cuenta'
    },
    "es_AR": {
        "shippingPhoneLabel": "Número de Teléfono en el Día",
        "shippingEmailInvalidMessage": "Esta no es una dirección de correo válida."
    },
    "es_CL": {
        "shippingPhoneLabel": "Número de Teléfono en el Día"
    },
    "es_CO": {
        "requiredMessage": "Este campo es requerido"
    },
    "es_CR": {
        "shippingPhoneLabel": "Número de Teléfono en el Día: (xxx-xxxx-xxxx)",
        "shippingNameLabel": "Nombre"
    },
    "es_ES": {
        "requiredMessage": "Es un campo obligatorio",
        "shippingPhoneLabel": "",
        "shippingEmailLabel": "Correo electrónico",
        "shippingAddressDefaultLabel": "Esta es mi dirección de envío por defecto.",
        "shippingAddressSaveLabel": "Guardar dirección de envío en Mi Cuenta"
    },
    "es_GT": {
        "shippingNameLabel": "Nombre"
    },
    "es_HN": {
        "shippingNameLabel": "Nombre"
    },
    "es_MX": {
        "shippingPhoneLabel": "Número de Teléfono en el Día (xxx-xxxx-xxxx)"
    },
    "es_SV": {
        "shippingNameLabel": "Nombre"
    },
    "es_US": {
        "shippingEmailInvalidMessage": "Correo electrónico invalido"
    },
    "es_VE": {
        "requiredMessage": "Es una área requeria",
        "shippingPhoneLabel": "Número de Teléfono en el Día (xxxx-xxx-xxxx)",
        "shippingNameLabel": "Nombre"
    },
    "fi": {
        "requiredMessage": "Tämä kenttä on pakollinen.",
        "shippingPhoneLabel": "Puhelinnumero paivisin",
        "shippingNameLabel": "Nimi",
        "shippingEmailLabel": "Email Address",
        "shippingEmailInvalidMessage": "Tämä ei ole voimassa oleva sähköpostiosoite",
        "shippingAddressDefaultLabel": "Tee tästä ensisijainen toimitusosoitteeni",
        "shippingAddressSaveLabel": "Tallenna tämä osoite tilitietoihini"
    },
    "fr": {
        "requiredMessage": "Ceci est un champ obligatoire.",
        "shippingPhoneLabel": "Numero de tel. professionnel",
        "shippingNameLabel": "Nom",
        "shippingEmailLabel": "Adresse e-mail",
        "shippingEmailInvalidMessage": "L'adresse électronique que vous nous avez fournie n'est pas valide ou est introuvable par le système.",
        "shippingInstructionsLabel": "Instructions d'expédition (facultatif)",
        "shippingAddressDefaultLabel": "Utilisez par défaut cette adresse d'expédition",
        "shippingAddressSaveLabel": "Sauvegardez cette adresse d'expedition dans Mon Profil"
    },
    "fr_CA": {
        "shippingPhoneLabel": "Numéro de téléphone (adresse d'expédition)",
        "shippingEmailLabel": "Adresse électronique"
    },
    "fr_NC": {
        "shippingPhoneLabel": "Numero de tel. professionnel (xx xxxx xxxx)",
        "shippingEmailLabel": "Adresse électronique"
    },
    "fr_PF": {
        "shippingPhoneLabel": "Numero de tel. professionnel (xx xxxx xxxx)",
        "shippingEmailLabel": "Adresse électronique"
    },
    "hu": {
        "requiredMessage": "E mező kitöltése kötelező.",
        "shippingPhoneLabel": "Napkozben hivhato telefonszam",
        "shippingNameLabel": "Név",
        "shippingEmailLabel": "E-mail cím",
        "shippingEmailInvalidMessage": "A megadott e-mail cím nem érvényes, illetve nem található meg a rendszerünkben.",
        "shippingAddressDefaultLabel": "Legyen ez az alapértelmezett szállítási címem.",
        "shippingAddressSaveLabel": "Cím mentése az azonosítóra"
    },
    "in": {
        "requiredMessage": "This field is required.",
        "shippingPhoneLabel": "Home Phone",
        "shippingNameLabel": "Nama Lengkap",
        "shippingAddressDefaultLabel": "Save as default shipping address",
        "shippingAddressSaveLabel": "Save this address to My Account"
    },
    "is": {
        "requiredMessage": "Þessa eyðu má ekki skilja eftir auða.",
        "shippingPhoneLabel": "Simanumer a daginn",
        "shippingNameLabel": "Viðtakandi",
        "shippingEmailLabel": "Netfang",
        "shippingEmailInvalidMessage": "Netfangið sem þú hefur skráð er ógilt eða ekki til á skrá.",
        "shippingAddressDefaultLabel": "Gerið þetta að sjálfkrafa stað afhendingar",
        "shippingAddressSaveLabel": "Vista þetta heimilisfang"
    },
    "it": {
        "requiredMessage": "Questo è un campo obbligatorio.",
        "shippingPhoneLabel": "Telefono durante il giorno",
        "shippingNameLabel": "Nome",
        "shippingEmailLabel": "Indirizzo email",
        "shippingEmailInvalidMessage": "L'indirizzo di e-mail fornito è invalido o non si trova nel nostro sistema.",
        "shippingAddressDefaultLabel": "Questo è l'indirizzo standard per la consegna",
        "shippingAddressSaveLabel": "Salva questo indirizzo ne Il mio Account"
    },
    "it_CH": {
        "requiredMessage": "Questo campo è obbligatorio.",
        "shippingEmailInvalidMessage": "L'indirizzo di e-mail da voi fornito è invalido o non si trova nel nostro sistema."
    },
    "iw": {
        "requiredMessage": "This field is required.",
        "shippingPhoneLabel": "מספר טלפון לשעות היום",
        "shippingNameLabel": "שם",
        "shippingEmailLabel": "כתובת דואר אלקטרוני",
        "shippingEmailInvalidMessage": "כתובת דואר אלקטרוני זו אינה תקפה",
        "shippingInstructionsLabel": "אנא ציינו כל הנחיה שיש לכם בנוגע למשלוח כאן",
        "shippingAddressDefaultLabel": "שמור ככתובת למשלוח ראשית",
        "shippingAddressSaveLabel": "שמור כתובת למשלוח לפרופיל שלי"
    },
    'ja': {
        "requiredMessage": "この項目は必須です。",
        "shippingPhoneLabel": "日中の電話番号：（例：0353213600）",
        "shippingNameLabel": "受取人氏名：",
        "shippingEmailLabel": "電子メールアドレス",
        "shippingEmailInvalidMessage": "有効なEメール アドレスではありません",
        "shippingAddressDefaultLabel": "第1配送先住所として保存",
        "shippingAddressSaveLabel": "この住所をマイ アカウントに保存",
        "shippingNameInvalidMessage": "特殊文字は使用できません"
    },
    "ms": {
        "requiredMessage": "This field is required.",
        "shippingPhoneLabel": "Home Phone",
        "shippingNameLabel": "Nama Penuh",
        "shippingAddressDefaultLabel": "Save as default shipping address",
        "shippingAddressSaveLabel": "Save this address to My Account"
    },
    "nl": {
        "requiredMessage": "Dit veld is verplicht.",
        "shippingPhoneLabel": "Telefoonnummer overdag",
        "shippingNameLabel": "Naam",
        "shippingEmailLabel": "Email Adres",
        "shippingEmailInvalidMessage": "Het e-mailadres dat u hebt opgegeven is ongeldig of kan niet gevonden worden in ons systeem.",
        "shippingAddressDefaultLabel": "Maak dit mijn standaardverzendadres.",
        "shippingAddressSaveLabel": "Bewaar dit adres op mijn account"
    },
    "nl_NL": {
        "requiredMessage": "Dit is een verplicht veld.",
        "shippingEmailInvalidMessage": "Het e-mailadres dat u heeft verstrekt, is ongeldig of zit niet in ons systeem."
    },
    "no": {
        "requiredMessage": "Dette er et obligatorisk felt.",
        "shippingPhoneLabel": "Tlf.nummer dag",
        "shippingNameLabel": "Navn",
        "shippingEmailLabel": "Epostadresse",
        "shippingEmailInvalidMessage": "E-mail adressen du har oppgitt er enten ugyldig eller finnes ikke i vårt system.",
        "shippingAddressDefaultLabel": "Gjør dette til min standard shippingadresse.",
        "shippingAddressSaveLabel": "Lagre denne adressen på kontoen min."
    },
    "pl": {
        "requiredMessage": "To pole należy obowiązkowo wypełnić.",
        "shippingPhoneLabel": "Numer kontaktowy",
        "shippingNameLabel": "Imie i nazwisko",
        "shippingEmailLabel": "Adres e-mail",
        "shippingEmailInvalidMessage": "Podany adres e-mail jest nieprawidłowy lub nie ma go w naszym systemie.",
        "shippingAddressDefaultLabel": "Chce, aby to byl mój domyslny adres wysylki.",
        "shippingAddressSaveLabel": "Zapisz ten adres na Moje Konto"
    },
    "pt": {
        "requiredMessage": "Campo é obrigatório",
        "shippingPhoneLabel": "Contacto telefónico durante o dia",
        "shippingNameLabel": "Nome",
        "shippingEmailLabel": "Endereço eletrónico",
        "shippingEmailInvalidMessage": "O correio eletrônico que você providenciou não é válido ou não foi encontrado no nosso sistema.",
        "shippingInstructionsLabel": "Instruções do frete (optional)",
        "shippingAddressDefaultLabel": "Guardar mi dirección de envío como principal",
        "shippingAddressSaveLabel": "Guardar dirección de envío en Mi Perfil"
    },
    "ro": {
        "requiredMessage": "Acest câmp este obligatoriu.",
        "shippingPhoneLabel": "Telefon de zi",
        "shippingNameLabel": "Nume",
        "shippingEmailLabel": "Adresa e-mail",
        "shippingEmailInvalidMessage": "Adresa de email oferită nu este validă sau nu este găsită în sistemul nostru.",
        "shippingAddressDefaultLabel": "Faceţi din aceasta adresa mea implicită de expediere.",
        "shippingAddressSaveLabel": "Salvaţi această adresă în Contul meu"
    },
    "ru": {
        "requiredMessage": "Это поле обязательно для заполнения.",
        "shippingPhoneLabel": "Номер телефона в дневное время",
        "shippingNameLabel": "Фамилия и Имя получателя (полностью)",
        "shippingEmailLabel": "Адрес электронной почты",
        "shippingEmailInvalidMessage": "Указанный адрес электронной почты недействителен.",
        "shippingAddressDefaultLabel": "Использовать этот адрес для доставки",
        "shippingAddressSaveLabel": "Сохранить этот адрес для моего Дистрибьюторского Номера"
    },
    "ru_UA": {
        "shippingPhoneLabel": "Номер телефона в дневное время: (необязательно)",
        "shippingNameLabel": "Пожалуйста введите имя получателя кириллицей в следующем порядке:Фамилие Имя Отчество"
    },
    "sk": {
        "requiredMessage": "Je potrebné vyplniť toto pole.",
        "shippingPhoneLabel": "Telefonne cislo pocas dna",
        "shippingNameLabel": "Meno",
        "shippingEmailLabel": "Emailová adresa",
        "shippingEmailInvalidMessage": "Emailovú adresu, ktorú ste poskytli je neplatná, alebo sa nenachádza v našom systéme.",
        "shippingAddressDefaultLabel": "Uložiť ako primárnu dodaciu adresu",
        "shippingAddressSaveLabel": "Uložiť túto adresu do môjho účtu"
    },
    "sv": {
        "requiredMessage": "Detta fält måste ifyllas.",
        "shippingPhoneLabel": "Telefonnummer dagtid",
        "shippingNameLabel": "Namn",
        "shippingEmailLabel": "E-mailadress",
        "shippingEmailInvalidMessage": "Angiven e-mailadress ogiltig alt. hittas inte i vårt system.",
        "shippingAddressDefaultLabel": "Spara som min huvudsakliga leveransadress.",
        "shippingAddressSaveLabel": "Spara adress under Mitt konto"
    },
    "th": {
        "requiredMessage": "กรุณากรอกข้อมูลนี้ให้ครบถ้วน",
        "shippingPhoneLabel": "โทรศัพท์ที่สามารถติดต่อได้",
        "shippingNameLabel": "ชื่อผู้รับ",
        "shippingEmailLabel": "อีเมล",
        "shippingEmailInvalidMessage": "ที่อยู่อีเมลนี้ไม่ถูกต้อง",
        "shippingInstructionsLabel": "เบอร์โทรศัพท์เคลื่อนที่",
        "shippingAddressDefaultLabel": "จัดเก็บเป็นที่อยู่หลักในการจัดส่ง",
        "shippingAddressSaveLabel": "จัดเก็บที่อยู่นี้ในระบบของข้าพเจ้า"
    },
    "th_NO": {
        "shippingAddressDefaultLabel": "ทำให้เป็นที่อยู่จัดส่งเริ่มต้นของฉัน.",
        "shippingAddressSaveLabel": "บันทึกที่อยู่นี้ในบัญชีของฉัน."
    },
    "th_SE": {
        "requiredMessage": "จำเป็นต้องกรอกช่องนี้",
        "shippingAddressDefaultLabel": "ทำให้เป็นที่อยู่จัดส่งเริ่มต้นของฉัน",
        "shippingAddressSaveLabel": "บันทึกที่อยู่นี้ในบัญชีของฉัน"
    },
    "th_TH": {
        "shippingPhoneLabel": "เบอร์โทรศัพท์บ้าน"
    },
    "tr": {
        "requiredMessage": "Bu alanı doldurmak zorunludur.",
        "shippingPhoneLabel": "Mesai Saatleri icin Telefon Numarasi",
        "shippingNameLabel": "Isim",
        "shippingEmailLabel": "Eposta Adresi",
        "shippingEmailInvalidMessage": "Girilen eposta adresi geçerli değildir",
        "shippingAddressDefaultLabel": "Bu adresi teslimat adresim olarak ayarla.",
        "shippingAddressSaveLabel": "Bu adresi Hesabımda kaydet"
    },
    "uk": {
        "requiredMessage": "Це поле є обов язковим для заповнення.",
        "shippingPhoneLabel": "Номер телефону в денний час: (необов'язково)",
        "shippingNameLabel": "Будь ласка введіть ім'я одержувача кирилицею у наступному порядку:Прізвище Ім'я По батькові",
        "shippingEmailLabel": "Адреса електронної пошти",
        "shippingEmailInvalidMessage": "Указана адреса електронної пошти недійсна.",
        "shippingAddressDefaultLabel": "Використовувати цю адресу для доставки",
        "shippingAddressSaveLabel": "Зберегти цю адресу для мого Дистриб'юторського Номера"
    },
    "vi": {
        "requiredMessage": "Trường thông tin bắt buộc",
        "shippingPhoneLabel": "Số điện thoại liên lạc: (xxx-xxx-xxxx)",
        "shippingNameLabel": "Tên",
        "shippingEmailLabel": "Điện thư",
        "shippingEmailInvalidMessage": "Thông tin không có thực",
        "shippingInstructionsLabel": "Hướng Dẫn về Chuyển Hàng (tùy chọn)",
        "shippingAddressDefaultLabel": "Lưu Lại Làm Địa Chỉ Chính",
        "shippingAddressSaveLabel": "Save this address to My Account"
    },
    'zh': {
        'requiredMessage': '这是必填栏。',
        'shippingPhoneLabel': '日间电话号码',
        'shippingNameLabel': '收件人姓名',
        'shippingNamePlaceholder': '姓名',
        'shippingNameInvalidMessage': '此姓名无效。',
        'shippingEmailInvalidMessage': '此电子邮件地址无效。',
        'shippingEmailLabel': '电子邮件地址',
        'shippingEmailPlaceholder': '电子邮件地址',
        'shippingInstructionsInvalidMessage': '该字段只能包含字符0-9。',
        'shippingInstructionsLabel': '运输说明（可选）',
        'shippingInstructionsPlaceholder': '运输说明',
        'shippingAddressDefaultLabel': '设置为我的默认收货地址。',
        'shippingAddressSaveLabel': '将此地址保存到我的帐户'
    }
};
